import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { authPost } from "../helpers/apiHelper";
import { useSelector } from "react-redux";
import { getErrors } from "../helpers/errorHelper";
import { Link } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  private: {
    paddingTop: theme.spacing(2),
    marginLeft: theme.spacing(0.5)
  }
}));

export default function CreateRoom({ showCreateRoom, setShowCreateRoom }) {
  const classes = useStyles();

  function handleClose() {
    setShowCreateRoom(false);
  }

  const { authToken } = useSelector(state => state.auth);

  const [roomName, setRoomName] = useState("");

  const [roomDescription, setRoomDescription] = useState("");

  const [privateRoom, setPrivateRoom] = useState(false);

  const [password, setPassword] = useState("");

  const [errors, setErrors] = useState([]);

  const [success, setSuccess] = useState(false);

  const [newRoom, setNewRoom] = useState({});

  const SubmitForm = async () => {
    let response = await authPost(authToken, "Room", "Create", {
      Name: roomName,
      Description: roomDescription,
      Private: privateRoom,
      Password: password
    });

    if (response.success) {
      setNewRoom(response.data.room);

      console.log(response);
      setSuccess(true);
    } else {
      setErrors(response.errors);
    }
  };

  return (
    <div>
      <Dialog
        open={showCreateRoom}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Create Room</DialogTitle>
        {!success && (
          <DialogContent>
            <DialogContentText>
              Fill out the form below to create a new room
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Room Name"
              fullWidth
              value={roomName}
              onChange={e => {
                setRoomName(e.target.value);
              }}
              error={getErrors("name", errors).length > 0}
              helperText={getErrors("name", errors)}
            />
            <TextField
              margin="dense"
              id="description"
              label="Room Description"
              value={roomDescription}
              onChange={e => {
                setRoomDescription(e.target.value);
              }}
              fullWidth
              error={getErrors("description", errors).length > 0}
              helperText={getErrors("description", errors)}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={privateRoom}
                  onChange={() => setPrivateRoom(!privateRoom)}
                  value="privateRoom"
                />
              }
              label="Private Room"
              labelPlacement="start"
              className={classes.private}
            />
            {privateRoom && (
              <TextField
                margin="dense"
                id="password"
                label="Room Password"
                value={password}
                onChange={e => {
                  setPassword(e.target.value);
                }}
                fullWidth
                type="password"
                error={getErrors("password", errors).length > 0}
                helperText={getErrors("password", errors)}
              />
            )}
          </DialogContent>
        )}
        {success && (
          <DialogContent>
            <DialogContentText>Successfully created room</DialogContentText>
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to={"/rooms/" + newRoom.roomId}
            >
              Join Room
            </Button>
          </DialogContent>
        )}
        {!success && (
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={SubmitForm} color="primary">
              Create
            </Button>
          </DialogActions>
        )}
        {success && (
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
